export default __webpack_public_path__ + "static/media/IMG_01644.21e6b4ae.jpeg";